export { default } from './StatCard';
export type { Props } from './StatCard';
